import { Environment, EnvironmentDomain, EnvironmentRedirectUrl } from './entities';

export const environment = {
  name: Environment.production,
  production: true,
  whitelabel: false,
  domain: EnvironmentDomain.production,
  productName: 'Inqud',
  productBaseUrl: 'inqud.com',
  redirectUrl: EnvironmentRedirectUrl.production,
};
